import { Component, ojs, app } from "modular-openscriptjs";

const h = app("h");

export default class Footer extends Component {
	render(...args) {
		return h.footer(
			{ class: "footer mt-4 d-none d-md-block sticky-bottom" },
			h.div(
				{ class: "text-center py-4" },
				h.div(
					{ class: "container" },
					h.p(
						{ class: "m-0" },
						"©",
						new Date().getFullYear(),
						" Carata 4.0, ",
						h.a(
							{ href: "https://carata.co", target: "_blank" },
							"Carata"
						),
						". All rights reserved."
					)
				)
			)
		);
	}
}

ojs(Footer);
